(function () {
  'use strict';

  const ACCENT_DEFAULT = '#17AAC7';
  const cache = new Map();

  function extractColor(url) {
    if (cache.has(url)) return Promise.resolve(cache.get(url));

    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);

          const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
          let r = 0, g = 0, b = 0, count = 0;

          for (let i = 0; i < data.length; i += 4 * 8) {
            const pr = data[i];
            const pg = data[i + 1];
            const pb = data[i + 2];
            const pa = data[i + 3];

            if (pa < 128) continue;
            const brightness = (pr + pg + pb) / 3;
            if (brightness > 250 || brightness < 10) continue;

            r += pr; g += pg; b += pb;
            count++;
          }

          if (count === 0) { resolve(ACCENT_DEFAULT); return; }

          r = Math.round(r / count);
          g = Math.round(g / count);
          b = Math.round(b / count);

          const color = saturate(r, g, b, 1.5);
          cache.set(url, color);
          resolve(color);
        } catch (e) {
          resolve(ACCENT_DEFAULT);
        }
      };
      img.onerror = () => resolve(ACCENT_DEFAULT);
      img.src = url;
    });
  }

  function saturate(r, g, b, factor) {
    r /= 255; g /= 255; b /= 255;
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;
    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
        case g: h = ((b - r) / d + 2) / 6; break;
        case b: h = ((r - g) / d + 4) / 6; break;
      }
    }
    s = Math.min(1, s * factor);
    let r2, g2, b2;
    if (s === 0) {
      r2 = g2 = b2 = l;
    } else {
      const hue2rgb = (p, q, t) => {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1/6) return p + (q - p) * 6 * t;
        if (t < 1/2) return q;
        if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
      };
      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;
      r2 = hue2rgb(p, q, h + 1/3);
      g2 = hue2rgb(p, q, h);
      b2 = hue2rgb(p, q, h - 1/3);
    }
    const toHex = x => Math.round(x * 255).toString(16).padStart(2, '0');
    return `#${toHex(r2)}${toHex(g2)}${toHex(b2)}`;
  }

  function initCard(card) {
    const url = card.dataset.colorImg;
    if (!url) return;

    // Pre-incarcam culoarea la init ca primul hover sa fie instant
    extractColor(url);

    card.addEventListener('mouseenter', async () => {
      const color = await extractColor(url);
      card.style.setProperty('--gdc-hover-color', color);
    });

    card.addEventListener('mouseleave', () => {
      card.style.removeProperty('--gdc-hover-color');
    });
  }

  function init() {
    document.querySelectorAll('.gdc-product-card').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver(mutations => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.classList?.contains('gdc-product-card')) initCard(node);
        else node.querySelectorAll?.('.gdc-product-card').forEach(initCard);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  function initCard(card) {
  const url = card.dataset.colorImg;
  if (!url) return;

  // Pre-incarcam culoarea la init
  extractColor(url);

  // Mouse hover - desktop
  card.addEventListener('mouseenter', async () => {
    const color = await extractColor(url);
    card.style.setProperty('--gdc-hover-color', color);
  });

  card.addEventListener('mouseleave', () => {
    // Pe mobile nu resetam la mouseleave
    if (window.matchMedia('(hover: hover)').matches) {
      card.style.removeProperty('--gdc-hover-color');
    }
  });

  // Intersection Observer - mobile
  const observer = new IntersectionObserver(async (entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting && !window.matchMedia('(hover: hover)').matches) {
        const color = await extractColor(url);
        card.style.setProperty('--gdc-hover-color', color);
      } else if (!entry.isIntersecting && !window.matchMedia('(hover: hover)').matches) {
        card.style.removeProperty('--gdc-hover-color');
      }
    }
  }, {
    threshold: 0.5
  });

  observer.observe(card);
}

})();